if (!customElements.get('ari-audio-player')) {
  class AriAudioPlayer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.audio = this.querySelector('audio');
      this.toggle = this.querySelector('[data-audio-toggle]');
      this.range = this.querySelector('[data-audio-range]');
      this.time = this.querySelector('[data-audio-time]');

      if (!this.audio || !this.toggle || !this.range || !this.time) return;

      this.dataset.ready = 'true';
      this.toggle.addEventListener('click', () => this.togglePlayback());
      this.range.addEventListener('input', () => this.seek());
      this.audio.addEventListener('timeupdate', () => this.updateProgress());
      this.audio.addEventListener('durationchange', () => this.updateProgress());
      this.audio.addEventListener('play', () => this.setPlaying(true));
      this.audio.addEventListener('pause', () => this.setPlaying(false));
      this.audio.addEventListener('ended', () => {
        this.audio.currentTime = 0;
        this.setPlaying(false);
        this.updateProgress();
      });
    }

    togglePlayback() {
      if (this.audio.paused) {
        document.querySelectorAll('ari-audio-player audio').forEach((audio) => {
          if (audio !== this.audio) audio.pause();
        });

        const playPromise = this.audio.play();
        if (playPromise) playPromise.catch(() => this.setPlaying(false));
      } else {
        this.audio.pause();
      }
    }

    seek() {
      if (!Number.isFinite(this.audio.duration) || this.audio.duration <= 0) return;
      this.audio.currentTime = (Number(this.range.value) / 100) * this.audio.duration;
    }

    updateProgress() {
      const duration = Number.isFinite(this.audio.duration) ? this.audio.duration : 0;
      const current = Number.isFinite(this.audio.currentTime) ? this.audio.currentTime : 0;
      this.range.value = duration > 0 ? String((current / duration) * 100) : '0';
      this.time.textContent = this.formatTime(current);
    }

    setPlaying(isPlaying) {
      this.classList.toggle('is-playing', isPlaying);
      this.toggle.setAttribute('aria-label', isPlaying ? 'Pause vocal preview' : 'Play vocal preview');
      this.toggle.setAttribute('aria-pressed', String(isPlaying));
    }

    formatTime(seconds) {
      const wholeSeconds = Math.max(0, Math.floor(seconds || 0));
      const minutes = Math.floor(wholeSeconds / 60);
      const remainder = String(wholeSeconds % 60).padStart(2, '0');
      return `${minutes}:${remainder}`;
    }
  }

  customElements.define('ari-audio-player', AriAudioPlayer);
}
